/** Shared map for handleMutationError across fiduciaire UI surfaces. */
export const FIDUCIAIRE_ERROR_CODE_MAP = {
  FIDUCIAIRE_SUBSCRIPTION_REQUIRED: 'fiduciaire:errors.subscriptionRequired',
  FIDUCIAIRE_BILLING_ACTIVE: 'fiduciaire:errors.billingActive',
  // Payer switch (takeOverBilling / handBackBilling / setMandateModules).
  ALREADY_FIDUCIAIRE_BILLED: 'fiduciaire:errors.alreadyFiduciaireBilled',
  NOT_FIDUCIAIRE_BILLED: 'fiduciaire:errors.notFiduciaireBilled',
  BILLING_MODULES_EMPTY: 'fiduciaire:errors.billingModulesEmpty',
  FIDUCIAIRE_ONLY: 'fiduciaire:errors.fiduciaireOnly',
  FIDUCIAIRE_OWN_COMPANY_HAS_MANDATES:
    'fiduciaire:errors.ownCompanyHasMandates',
  // Longest first: `handleMutationError` matches by substring.
  NOT_AN_OWNED_MANDATE: 'fiduciaire:errors.notAnOwnedMandate',
  NOT_AN_EXTERNAL_MANDATE: 'fiduciaire:errors.notAnExternalMandate',
  NOT_A_MANDATE: 'fiduciaire:errors.notAMandate',
  MANDATE_ALREADY_OWNED: 'fiduciaire:errors.mandateAlreadyOwned',
  ALREADY_MEMBER: 'fiduciaire:errors.alreadyMember',
  MANDATE_REQUEST_LIMIT_REACHED: 'fiduciaire:errors.requestLimitReached',
  MANDATE_REQUEST_NOT_PENDING: 'fiduciaire:errors.requestNotPending',
  MANDATE_REQUEST_NOT_FOUND: 'fiduciaire:errors.requestNotFound',
  MANDATE_REQUEST_RESEND_COOLDOWN: 'fiduciaire:errors.resendCooldown',
  MANDATE_REQUEST_STILL_OPEN: 'fiduciaire:errors.requestStillOpen',
  MANDATE_NOT_ACCEPTED: 'fiduciaire:errors.mandateNotAccepted',
  IDE_ALREADY_USED: 'fiduciaire:errors.ideAlreadyUsed',
  INVALID_IDE: 'fiduciaire:errors.invalidIde',
} as const;

/** Company profile saves: the UID is unique and must be a real one. */
export const COMPANY_IDE_ERROR_CODE_MAP = {
  IDE_ALREADY_USED: 'company:errors.ideAlreadyUsed',
  INVALID_IDE: 'company:errors.ideInvalid',
} as const;
